class GiftCardAddressForm extends HTMLElement {
  connectedCallback() {
    const checkbox = this.querySelector('input[name="properties[_show_gift_card_address_form]"]');
    const container = this.querySelector('.gift-card-address-form__fields');
    const fields = this.querySelectorAll('input[name*="properties[_recipient_"]');
    
    if (!checkbox || !container) return;
    
    const toggle = () => {
      const checked = checkbox.checked;
      container.toggleAttribute('hidden', !checked);
      fields.forEach(field => field.disabled = !checked);
    };
    
    checkbox.addEventListener('change', toggle);
    toggle();
  }
}

customElements.define('gift-card-address-form', GiftCardAddressForm);
